import axios from 'axios'
import baseUrl from '../helpers/baseurl'
import apiClient from './axiosClient/index'

export async function multipleGetApiCall(paths) {
  const setResponse = []
  const functionsget = []
  paths.forEach((element, index) => {
    const promisecur = apiClient.get(paths[index].path, {
      params: paths[index].params,
    }).then(res => ({ res: res, promise: `promise${index}` }))
    functionsget.push(promisecur)
  })

  await Promise.all(functionsget)
    .then((response) => {
      response.forEach((element, ind) => {
        setResponse.push(element.res.data.data.data)
      })
      return setResponse
    })
  return setResponse
}

export async function getTable(resourceEndpoint, params = '') {
  const response = await apiClient.get(`${resourceEndpoint}${params}`)
  return response.data
}

export async function getApiCall(resourceEndpoint, params = {}) {
  const response = await apiClient.get(`/${resourceEndpoint}`, {
    params: params,
  })
  return response.data
}

export async function postApiCall(resourceEndpoint, body, config = {}) {
  const response = await apiClient.post(`/${resourceEndpoint}`, { ...body }, { ...config })
  return response.data
}

export async function loginGoogle(body1) {
  const response = await axios.post(
    `${baseUrl}auth/google-login`,
    body1,
    {
      headers: {
        'Content-Type': 'application/json'
      },
    }
  )
  return response.data
}

export async function postApiFileCall(resourceEndpoint, body, config = {}) {
  const response = await apiClient.post(`/${resourceEndpoint}`, { ...body }, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    ...config,
  })
  return response.data
}

export async function putApiCall(resourceEndpoint, body, config = {}) {
  const response = await apiClient.put(`/${resourceEndpoint}`, { ...body }, { ...config })
  return response.data
}

export async function patchApiCall(resourceEndpoint, body, config = {}) {
  const response = await apiClient.patch(`/${resourceEndpoint}`, { ...body }, { ...config })
  return response.data
}

export async function patchApiFileCall(resourceEndpoint, body, config = {}) {
  const response = await apiClient.patch(`/${resourceEndpoint}`, { ...body }, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return response.data
}

export async function deleteApiCall(resourcetype, config = {}) {
  const response =  await apiClient.delete(`/${resourcetype}`, config)
  return response.data
}